export default {
  namespaced: true,
  state: {
    api: {},
    energy_type: null,
    name: null,
    code: null,
    file: null,
  },
  mutations: {
    SET_ITEM(state, data) {
      state[data[0]] = data[1];
    },
  },
  actions: {
    VALIDATE_SUPPLIER({ dispatch, state }) {
      if (state.name && state.code && state.energy_type) {
        dispatch('CREATE_SUPPLIER');
      } else {
        this._vm.$notify({
          group: 'foo',
          type: 'error',
          title: 'Wichtige Mitteilung',
          text: 'Nicht alle Pflichtfelder ausgefüllt.',
        });
      }
    },
    async CREATE_SUPPLIER({ commit, state }) {
      try {
        const response = await axios.post(state.api.create, {
          name: state.name,
          energy_type: state.energy_type.id,
          code: state.code,
        });
        this._vm.$notify({
          group: 'foo',
          type: 'success',
          title: 'Wichtige Mitteilung',
          text: 'Vorlieferanten erstellt',
        });
        window.location.href = state.api['pre-suppliers'];
      } catch (err) {
        if (err.response.status == 422) {
          this._vm.$notify({
            group: 'foo',
            type: 'error',
            title: 'Wichtige Mitteilung',
            text: err.response.data.errors,
          });
        } else {
          throw Error(err);
        }
      }
    },
    async UPLOAD_SUPPLIER({ commit, state }) {
      const formData = new FormData();
      formData.append('file', state.file[0], state.file[0].name);
      try {
        const response = await axios.post(state.api.upload, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        });
        window.location.href = state.api.back_link;
      } catch (err) {
        if (err.response.status == 422) {
          for (const error in err.response.data.errors) {
            this._vm.$notify({
              group: 'foo',
              type: 'error',
              title: 'Wichtige Mitteilung',
              text: err.response.data.errors[error][0],
            });
          }
        } else {
          throw Error(err);
        }
      }
    },
  },
};
